/* Pop-up « mini-diagnostic » Bougie Frenchie (sections/bf-popup-quiz.liquid) */
(function () {
  function store(key, val) {
    try { if (val === undefined) return localStorage.getItem(key); if (val === null) localStorage.removeItem(key); else localStorage.setItem(key, val); } catch (e) { return null; }
  }

  function init(root) {
    if (root.dataset.bfPqReady) return;
    root.dataset.bfPqReady = '1';
    var key = root.dataset.key || 'bfpq';
    var days = parseInt(root.dataset.days, 10) || 14;
    var delay = (parseInt(root.dataset.delay, 10) || 0) * 1000;
    var scrollPct = parseInt(root.dataset.scroll, 10) || 0;
    var design = root.dataset.design === 'true';
    var dialog = root.querySelector('.bf-pq__dialog');
    var steps = Array.prototype.slice.call(root.querySelectorAll('.bf-pq__step'));
    var questions = steps.filter(function (s) { return s.dataset.step === 'q'; });
    var bar = root.querySelector('[data-bf-pq-bar]');
    var img = root.querySelector('.bf-pq__img');
    var scores = {};
    var current = 'intro';
    var lastFocus = null;
    var opened = false;

    var success = !!root.querySelector('[data-bf-pq-success-flag]');
    var error = !!root.querySelector('[data-bf-pq-error-flag]');

    function snoozed() {
      var t = parseInt(store(key), 10);
      return t && Date.now() - t < days * 864e5;
    }
    function snooze() { store(key, String(Date.now())); }

    function show(stepEl) {
      steps.forEach(function (s) { s.classList.toggle('is-active', s === stepEl); });
      current = stepEl.dataset.step;
      var total = questions.length + 1;
      var done = current === 'intro' ? 0 : current === 'q' ? parseInt(stepEl.dataset.q, 10) - 1 : total;
      if (bar) bar.style.width = Math.round((done / total) * 100) + '%';
      var count = stepEl.querySelector('[data-bf-pq-count]');
      if (count) count.textContent = (root.dataset.count || '').replace('[n]', stepEl.dataset.q).replace('[total]', questions.length);
      var focusable = stepEl.querySelector('button, a, input');
      if (opened && focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 40);
      root.classList.toggle('is-result', current === 'result' || current === 'success');
    }

    function open() {
      if (opened) return;
      opened = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('bf-pq-lock');
      void root.offsetWidth;
      root.classList.add('is-open');
      var active = steps.filter(function (s) { return s.classList.contains('is-active'); })[0];
      if (active) show(active);
      document.addEventListener('keydown', onKey);
    }

    function close() {
      if (!opened) return;
      opened = false;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('bf-pq-lock');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { root.hidden = true; }, 250);
      if (!design) snooze();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(dialog.querySelectorAll('button, a[href], input:not([type=hidden])')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function resultStep() { return steps.filter(function (s) { return s.dataset.step === 'result'; })[0]; }

    function showResult(name) {
      var results = Array.prototype.slice.call(root.querySelectorAll('[data-result]'));
      var chosen = null;
      results.forEach(function (r) {
        var match = name && r.dataset.result.toLowerCase() === name.toLowerCase();
        r.hidden = !match;
        if (match) chosen = r;
      });
      if (chosen) {
        var rImg = chosen.querySelector('img');
        if (img && rImg) { img.srcset = rImg.srcset || ''; img.src = rImg.src; }
        var link = chosen.querySelector('a');
        store(key + '-scent', JSON.stringify({ name: chosen.dataset.result, url: link ? link.getAttribute('href') : '' }));
        var tags = root.querySelector('[data-bf-pq-tags]');
        if (tags) tags.value = 'newsletter,diagnostic-popup,senteur-' + chosen.dataset.result.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-');
      }
      show(resultStep());
    }

    function winner() {
      var names = Array.prototype.slice.call(root.querySelectorAll('[data-result]')).map(function (r) { return r.dataset.result; });
      var best = null, bestScore = -1;
      names.forEach(function (n) { var sc = scores[n.toLowerCase()] || 0; if (sc > bestScore) { best = n; bestScore = sc; } });
      return best;
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bf-pq-close],[data-bf-pq-start],[data-bf-pq-skip],[data-bf-pq-a],[data-bf-pq-copy]');
      if (!t) return;
      if (t.hasAttribute('data-bf-pq-close')) { close(); return; }
      if (t.hasAttribute('data-bf-pq-start')) { scores = {}; if (questions[0]) show(questions[0]); else showResult(winner()); return; }
      if (t.hasAttribute('data-bf-pq-skip')) {
        Array.prototype.slice.call(root.querySelectorAll('[data-result]')).forEach(function (r) { r.hidden = true; });
        store(key + '-scent', null);
        show(resultStep());
        return;
      }
      if (t.hasAttribute('data-bf-pq-a')) {
        var pts = parseInt(t.dataset.points, 10) || 1;
        (t.dataset.scents || '').split(',').forEach(function (n) { n = n.trim().toLowerCase(); if (n) scores[n] = (scores[n] || 0) + pts; });
        var step = t.closest('[data-step]');
        var idx = questions.indexOf(step);
        if (questions[idx + 1]) show(questions[idx + 1]); else showResult(winner());
        return;
      }
      if (t.hasAttribute('data-bf-pq-copy')) {
        var code = root.querySelector('[data-bf-pq-code]');
        if (code && navigator.clipboard) navigator.clipboard.writeText(code.textContent.trim()).then(function () { t.textContent = t.dataset.done; });
      }
    });

    root._bfOpen = open;
    root._bfClose = close;

    var form = root.querySelector('form');
    if (form) form.addEventListener('submit', function () {
      store(key + '-sent', '1');
      var fn = form.querySelector('[name="contact[first_name]"]');
      store(key + '-name', fn && fn.value.trim() ? fn.value.trim() : null);
    });

    if (success && store(key + '-sent')) {
      var saved = null;
      try { saved = JSON.parse(store(key + '-scent') || 'null'); } catch (e) {}
      var line = root.querySelector('[data-bf-pq-success-scent]');
      var tpl = root.dataset.successScent || '';
      if (saved && saved.name && line && tpl) { line.textContent = tpl.replace('[senteur]', saved.name); line.hidden = false; }
      var hello = root.querySelector('[data-bf-pq-hello]');
      var firstName = store(key + '-name');
      if (hello && firstName && hello.dataset.tpl) hello.textContent = hello.dataset.tpl.replace('[prénom]', firstName);
      store(key + '-name', null);
      var sl = root.querySelector('[data-bf-pq-success-link]');
      if (saved && saved.url && sl) sl.href = saved.url;
      show(steps.filter(function (s) { return s.dataset.step === 'success'; })[0]);
      open();
      snooze();
      store(key + '-sent', null);
      return;
    }
    if (error && store(key + '-sent')) {
      var savedE = null;
      try { savedE = JSON.parse(store(key + '-scent') || 'null'); } catch (e) {}
      showResult(savedE && savedE.name);
      open();
      return;
    }
    if (design) return;
    if (root.dataset.mobile === 'false' && window.matchMedia('(max-width: 767px)').matches) return;
    if (snoozed()) return;

    var timer = setTimeout(open, delay);
    if (scrollPct > 0) {
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && (window.scrollY / h) * 100 >= scrollPct) { window.removeEventListener('scroll', onScroll); clearTimeout(timer); open(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  function boot() { document.querySelectorAll('[data-bf-pq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Éditeur de thème : ouvrir la pop-up quand la section ou un bloc est sélectionné
  document.addEventListener('shopify:section:load', boot);
  ['shopify:section:select', 'shopify:block:select'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var root = e.target.querySelector ? e.target.querySelector('[data-bf-pq]') || e.target.closest('[data-bf-pq]') : null;
      if (!root) return;
      init(root);
      if (root._bfOpen) root._bfOpen();
      else { root.hidden = false; root.classList.add('is-open'); }
      if (ev === 'shopify:block:select') {
        var step = e.target.closest('.bf-pq__step') || e.target;
        if (step && step.classList.contains('bf-pq__step')) {
          root.querySelectorAll('.bf-pq__step').forEach(function (s) { s.classList.toggle('is-active', s === step); });
        }
        var res = e.target.closest('[data-result]');
        if (res) {
          root.querySelectorAll('.bf-pq__step').forEach(function (s) { s.classList.toggle('is-active', s.dataset.step === 'result'); });
          root.querySelectorAll('[data-result]').forEach(function (r) { r.hidden = r !== res; });
        }
      }
    });
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-bf-pq]') : null;
    if (root && root._bfClose) root._bfClose();
  });
})();
